import { type RouteRecordRaw } from 'vue-router'

export const agentRouter: RouteRecordRaw[] = [
  {
    component: async () => await import('../views/AgentView.vue'),
    meta: {
      title: 'agent',
    },
    name: 'brand.agent',
    path: 'agent',
  },
]
